module.exports = __webpack_public_path__ + "img/gel-30.8f128c00.jpg";